export const AU_STATES = {
  VICTORIA: 'VIC',
};
